import { createStorage } from '@sg/mmkv-storage';

// ─────────────────────────────────────────────────────────────────────────────

export const permissionsStorage = createStorage({ id: 'sg.permissions' });
